import styled from 'styled-components';
import { motion } from 'framer-motion';

export const TeamContainer = styled.div`
	color: #fff;
	padding: 80px 0;
	border-radius: 10px;
	background: ${({ inverse }) => (inverse ? '#04403e' : '#066a67')};
`;

export const TeamWrapper = styled.div`
	display: grid;
	z-index: 1;
	width: 100%;
	max-width: 1300px;
	margin-left: auto;
	margin-right: auto;
	padding: 0 24px;
	justify-content: center;
`;

export const TeamTitle = styled(motion.h1)`
	margin-bottom: 24px;
	font-size: 3rem;
	line-height: 1.1;
	font-weight: 600;
	color: ${({ inverse }) => (inverse ? '#f7f8fa' : '#000000')};
	text-align: center;

	@media screen and (max-width: 768px) {
		font-size: 2rem;
	}
`;

export const TeamSubtitle = styled(motion.p)`
	max-width: 600px;
	margin: 0 auto 80px auto;
	font-size: 1.5rem;
	line-height: 1.5;
	color: ${({ inverse }) => (inverse ? '#a9b3c1' : '#333333')};
	text-align: center;

	@media screen and (max-width: 768px) {
		font-size: 1.2rem;
		margin-bottom: 60px;
	}
`;

export const TeamGrid = styled(motion.div)`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
	gap: 30px;
	align-items: stretch;
	justify-items: center;
	max-width: 1200px;
	margin: 0 auto;

	@media screen and (max-width: 1200px) {
		grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
		gap: 25px;
	}

	@media screen and (max-width: 768px) {
		grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
		gap: 20px;
		padding: 0 10px;
	}

	@media screen and (max-width: 480px) {
		grid-template-columns: 1fr;
		gap: 20px;
		padding: 0 5px;
	}
`;

export const TeamCard = styled(motion.div)`
	background: ${({ inverse }) => (inverse ? '#04403e' : '#f9f9f9')};
	border-radius: 10px;
	padding: 20px;
	text-align: center;
	box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
	transition: all 0.3s ease;
	width: 100%;
	max-width: 300px;
	min-height: 280px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	&:hover {
		box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
		transform: translateY(-5px);
	}

	@media screen and (max-width: 768px) {
		padding: 15px;
		min-height: 250px;
		max-width: 280px;
	}

	@media screen and (max-width: 480px) {
		padding: 15px;
		min-height: 240px;
		max-width: 100%;
	}
`;

export const TeamImage = styled.img`
	width: 120px;
	height: 120px;
	border-radius: 50%;
	object-fit: cover;
	margin-bottom: 20px;
	border: 4px solid #18776a;
	transition: all 0.3s ease;

	&:hover {
		border-color: #18776a;
		transform: scale(1.05);
	}

	@media screen and (max-width: 768px) {
		width: 100px;
		height: 100px;
		margin-bottom: 15px;
	}

	@media screen and (max-width: 480px) {
		width: 90px;
		height: 90px;
		margin-bottom: 15px;
	}
`;

export const TeamInfo = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const TeamName = styled.h3`
	font-size: 1.4rem;
	font-weight: 600;
	color: ${({ inverse }) => (inverse ? '#f7f8fa' : '#000000')};
	margin: 0 0 8px 0;
	text-align: center;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;

	@media screen and (max-width: 768px) {
		font-size: 1.2rem;
	}

	@media screen and (max-width: 480px) {
		font-size: 1.1rem;
		white-space: normal;
		overflow: visible;
		text-overflow: unset;
	}
`;

export const TeamPosition = styled.p`
	font-size: 1rem;
	color: ${({ inverse }) => (inverse ? '#a9b3c1' : '#444444')};
	margin: 0;
	line-height: 1.4;
	text-align: center;
	font-weight: 400;

	@media screen and (max-width: 768px) {
		font-size: 0.9rem;
	}

	@media screen and (max-width: 480px) {
		font-size: 0.85rem;
	}
`;
